import React from 'react'
import DataTable from './previsional/DataTable'
import DashboardResultados from './DashboardResultados'
import AnalisisDeEstrategia from './AnalisisDeEstrategia'

export default function ResultadosTabCompleta({
  formStep, calculoReady, rows, rowsVista, goToStep, ultimoPeriodoDetectado,
  showAllDetalle, setShowAllDetalle, modoHerramienta, indicesLoading,
  dataTablePage, setDataTablePage, setRowsEditadas, activeRules,
  expediente, contextoDictamen,
}) {
  return (
    <div className="mt-4 space-y-4">
      {formStep >= 5 && calculoReady && rowsVista.length > 0 && (
        <div className="flex justify-start">
          <button
            type="button"
            onClick={() => goToStep(4)}
            className="rounded-xl border border-amber-300/45 bg-amber-500/15 px-4 py-2 text-sm font-semibold text-amber-100"
          >
            Volver a corregir tabla
          </button>
        </div>
      )}
      {formStep >= 5 && calculoReady && ultimoPeriodoDetectado && <p className="text-xs text-slate-300">Último período detectado en PDF: {ultimoPeriodoDetectado}</p>}

      {formStep >= 5 && calculoReady && rows.length > 0 && (
        <details className="rounded-2xl border border-white/20 bg-white/10 p-3 backdrop-blur-2xl">
          <summary className="cursor-pointer list-none text-sm font-semibold text-slate-100">Ver detalle tecnico del historial cargado</summary>
          <p className="mt-2 text-xs text-slate-300">{showAllDetalle ? 'Todos los periodos cargados.' : 'Primeras 12 filas (control documental).'}</p>
          <div className="mt-2 overflow-x-auto">
            <table className="min-w-full text-sm text-slate-100">
              <thead>
                <tr className="text-left text-xs text-slate-300">
                  <th className="px-2 py-1">Periodo</th>
                  <th className="px-2 py-1">Empresa</th>
                  <th className="px-2 py-1">CUIT</th>
                  <th className="px-2 py-1">Monto</th>
                </tr>
              </thead>
              <tbody>
                {rows.slice().sort((a, b) => String(a.periodoKey || '').localeCompare(String(b.periodoKey || ''))).slice(0, showAllDetalle ? rows.length : 12).map((r, i) => (
                  <tr key={`review-${i}`} className="border-t border-white/10">
                    <td className="px-2 py-1">{r.periodo || r.periodoISO || r.periodoKey}</td>
                    <td className="px-2 py-1">{r.empresa || r.razonSocial || 'S/D'}</td>
                    <td className="px-2 py-1">{r.cuit || 'S/D'}</td>
                    <td className="px-2 py-1">${Number(r.monto || r.remImpSS || r.montoOriginal || 0).toLocaleString('es-AR')}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {rows.length > 12 && (
              <button type="button" onClick={() => setShowAllDetalle((p) => !p)} className="mt-2 rounded-lg border border-white/25 bg-white/10 px-3 py-1.5 text-xs font-semibold text-white">
                {showAllDetalle ? 'Mostrar menos' : `Mostrar todas (${rows.length} filas)`}
              </button>
            )}
          </div>
        </details>
      )}

      {modoHerramienta === 'avanzado' && (
        <div>
          {indicesLoading ? (
            <div className="rounded-xl border border-white/20 bg-white/10 p-4">
              <div className="mb-3 h-4 w-40 animate-pulse rounded bg-white/20" />
              <div className="space-y-2">
                <div className="h-10 w-full animate-pulse rounded bg-white/10" />
                <div className="h-10 w-full animate-pulse rounded bg-white/10" />
                <div className="h-10 w-full animate-pulse rounded bg-white/10" />
                <div className="h-10 w-full animate-pulse rounded bg-white/10" />
              </div>
            </div>
          ) : (
            <>
              {(() => {
                const ROWS_PER_PAGE = 24
                const totalPages = Math.ceil(rowsVista.length / ROWS_PER_PAGE)
                const safePage = Math.min(dataTablePage, Math.max(totalPages, 1))
                const start = (safePage - 1) * ROWS_PER_PAGE
                const pageRows = rowsVista.slice(start, start + ROWS_PER_PAGE)
                return (
                  <>
                    <DataTable rows={pageRows} onRowsChange={(edited) => {
                      const full = [...rowsVista]
                      edited.forEach((row, i) => { full[start + i] = row })
                      setRowsEditadas(full)
                    }} />
                    {totalPages > 1 && (
                      <div className="mt-3 flex flex-wrap items-center justify-center gap-1.5">
                        {Array.from({ length: totalPages }, (_, i) => (
                          <button
                            key={i + 1}
                            type="button"
                            onClick={() => setDataTablePage(i + 1)}
                            className={`min-w-[32px] rounded-lg px-2.5 py-1.5 text-xs font-semibold transition-all ${safePage === i + 1 ? 'panel-profile-accent text-profile-accent' : 'panel-profile text-slate-300 hover:text-white'}`}
                          >
                            {i + 1}
                          </button>
                        ))}
                      </div>
                    )}
                  </>
                )
              })()}
            </>
          )}
        </div>
      )}

      {!indicesLoading && rowsVista.length > 0 && (
        <div>
          <DashboardResultados auditoriaRows={rowsVista} titulo="Auditoria Tecnica" />
          <AnalisisDeEstrategia strategicRules={activeRules} expediente={expediente} contextoDictamen={contextoDictamen} />
        </div>
      )}
    </div>
  )
}
